import UiDynamischeZahlenReadOnlyElement from "./UiDynamischeZahlenReadOnlyElement/UiDynamischeZahlenReadOnlyElement.vue";
import translate from "../../../../../../global/directives/translate";

// @vue/component
export default {
  name: "UiDynamischeZahlenReadOnly",
  components: {
    UiDynamischeZahlenReadOnlyElement,
  },
  directives: {
    translate,
  },
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    className: {
      type: String,
      default: "",
    },
    model: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: undefined,
    },
  },
};
